import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHolder, apis, AiStaffCreateStep } from 'api';
const aiStaffApi = apiHolder.api.requireLogicalApi(apis.aiStaffApiImpl);
const initialState = {
    aiStaffKeepAlive: false,
    aiTeamKeepAlive: true,
    errorAlertsFetchTime: 0,
    createStep: null,
    staffInfoDraft: null,
    staffInfo: null,
    staffInfoFetching: false,
    staffStatusSwitching: false,
    initialEnterpriseInfo: null,
    initialEnterpriseInfoFetching: false,
};
export const getStaffInfoAsync = createAsyncThunk('ai-staff/getStaffInfoAsync', async ({ staffId, config }) => {
    if (!staffId) {
        const { exists, staff_id } = await aiStaffApi.getStaffExists(config);
        if (!exists)
            return Promise.reject();
        staffId = staff_id;
    }
    const staffInfo = await aiStaffApi.getStaffInfo({ staff_id: staffId }, config);
    return staffInfo;
});
export const getInitialEnterpriseInfo = createAsyncThunk('ai-staff/getInitialEnterpriseInfo', async () => {
    return await aiStaffApi.getEnterpriseInfo();
});
const aiStaffSlice = createSlice({
    name: 'aiStaffSlicer',
    initialState,
    reducers: {
        update(state, action) {
            const payload = typeof action.payload === 'function' ? action.payload(state) : action.payload;
            Object.entries(payload).forEach(([key, value]) => {
                state[key] = value;
            });
        },
        updateErrorAlerts(state) {
            state.errorAlertsFetchTime = Date.now();
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getStaffInfoAsync.pending, (state, action) => {
            if (action.meta.arg.showLoading) {
                state.staffInfoFetching = true;
            }
        })
            .addCase(getStaffInfoAsync.fulfilled, (state, action) => {
            if (action.meta.arg.showLoading) {
                state.staffInfoFetching = false;
            }
            state.staffInfo = action.payload;
        })
            .addCase(getStaffInfoAsync.rejected, (state, action) => {
            if (action.meta.arg.showLoading) {
                state.staffInfoFetching = false;
            }
            state.createStep = AiStaffCreateStep.name;
        })
            .addCase(getInitialEnterpriseInfo.pending, state => {
            state.initialEnterpriseInfoFetching = true;
        })
            .addCase(getInitialEnterpriseInfo.fulfilled, (state, action) => {
            state.initialEnterpriseInfoFetching = false;
            state.initialEnterpriseInfo = action.payload;
        })
            .addCase(getInitialEnterpriseInfo.rejected, state => {
            state.initialEnterpriseInfoFetching = false;
        });
    },
});
export const { actions } = aiStaffSlice;
export default aiStaffSlice.reducer;
